import { Field } from 'app/components/core/Form';

export function JobUidHiddenField() {
    return <Field component="input" type="hidden" name="uid" />;
}
